import React, { useMemo } from "react";
import { styled, css } from "../../stitches.config";
import { Field, FormikProps, ErrorMessage, FieldAttributes } from "formik";
import { CSSTransition } from "react-transition-group";

import CircleButton from "../CircleButton";
import { useWindowWidth, pushDataLayer } from "../../helpers";
import Tile from "./Parts/Brid/BridPaymentModal/Tile";

import { DONATE_VALUES } from "../ArticleBrid";
import { IFormValues } from "../ArticleBrid";
import { ReactComponent as BridTick } from "../../assets/img/brid_correct.svg?react";

interface IProps {
  setShowModal: (value: boolean) => void;
  isSummary?: boolean;
  isBridPaymentModalOpen?: boolean;
}

const BridDonate: React.FC<IProps & FormikProps<IFormValues>> = ({
  setShowModal,
  values,
  errors,
  isSummary,
  isBridPaymentModalOpen,
  ...props
}) => {
  const width = useWindowWidth();
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    // window.gtag('event', 'Modal Open', {
    //   event_category: 'BRID',
    //   event_label: window.location.pathname
    // })
    pushDataLayer({
      event: "analyticsEvent",
      eventCategory: "BRID",
      eventAction: "Modal open",
      eventLabel: window.location.pathname,
      eventValue: undefined,
    });
    setShowModal(true);
  };

  const tiles = DONATE_VALUES.map((item, index) => {
    return (
      <RadioTile key={`checkbox_donate_${index}`}>
        <Field
          id={`donate_${item}`}
          name="donateAmount"
          type="radio"
          value={item}
          checked={values.donateAmount === item}
        />
        <label htmlFor={`donate_${item}`}>
          <RadioButton>
            <p>{item === "own" ? 'inna' : `${item}zł`}</p>
          </RadioButton>
        </label>
      </RadioTile>
    );
  });

  return (
    <Wrap className={isBridPaymentModalOpen ? "brid-donate" : ""}>
      {/* {width > 992 && <S.H3>Wesprzyj Projekt</S.H3>} */}
      <WrapperOptions>
        <AmountTileWrap>{tiles}</AmountTileWrap>
        {/* <AmountTileWrap>{tiles.slice(3, 6)}</AmountTileWrap> */}
        {/* <AmountTileWrap>{tiles.slice(6, 9)}</AmountTileWrap> */}
        {!isSummary && (
          <>
            {values.donateAmount === "own" && (
              <div style={{ position: "relative" }}>
                <BridInput
                  name="donateCustomAmount"
                  placeholder="Kwota..."
                  error={errors.donateCustomAmount?.toString()}
                  touched={props.touched.donateCustomAmount?.toString()}
                />
                <BridTick />
              </div>
            )}
          </>
        )}

        {isSummary && (
          <>
            <p className="brid-donate-summary">
              <><b>Redakcja naTemat finansuje 50% budżetu </b>każdego
                projektu, który zostanie wybrany przez czytelników.
                Redakcji zależy na opinii użytkowników i chce współtworzyć
                portal wspólnie z nimi opierając się na ich opinii oraz
                interesujących ich tematów.</>
            </p>
            {values.donateAmount === "own" && (
              <div style={{ position: "relative" }} className="brid-donate-own">
                <label>Wpisz kwotę</label>
                <BridInput
                  isSummary={isSummary}
                  name="donateCustomAmount"
                  placeholder="Kwota..."
                  error={errors.donateCustomAmount?.toString()}
                  touched={props.touched.donateCustomAmount?.toString()}
                />
                <BridTick />
                <ErrorMessage name="donateCustomAmount" />
              </div>)}
          </>
        )}

      </WrapperOptions>
      {/* {width > 992 && ( */}
      {!isSummary && (
        <StyledButton onClick={handleClick}>Wesprzyj projekt</StyledButton>
      )}
      {/* )} */}
    </Wrap>
  );
};

const StyledButton = styled(CircleButton, {
  width: "100% !important",
  margin: "0",
  marginBottom: "16px",
  "&:hover": {
    ".circle": {
      backgroundColor: "$primary120 !important"
    }
  },
  ".circle": {
    width: "100% !important",
    backgroundColor: "$primary !important",
    borderRadius: "0 !important",
    margin: "0",
    ".icon": {
      display: "none",
      "&.arrow": {
        background: "#272424 !important"
      }
    },
  },
  "span": {
    textTransform: "capitalize !important",
    fontWeight: 600,
    margin: "0 !important",
    color: "#fff !important"
  }
});
const WrapperOptions = styled("div", {
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  width: "100%"
});
const RadioButton = styled("span", {
  width: "95%",
  height: "48px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "3px",
  border: "2px solid #3a3a3a",
  "&:after": {
    content: "",
    position: "absolute",
    display: "none"
  }
});

const BridInput: React.FC<FieldAttributes<any> & { touched?: string; isSummary: boolean }> = ({ className, touched, error, isSummary, ...props }) => {

  const styles = useMemo(() => css({
    display: "block",
    marginBottom: "8px",
    padding: "13px 20px",
    width: isSummary ? "50%" : "100%",
    border: "solid 2px #7373733d",
    color: "#737373",
    fontSize: "16px",
    backgroundColor: "transparent",
    /* border-color: ${(props: any) =>
    !props.error && props.touched && "black"}; */
    transition: "border-color 500ms",
    "&::placeholder": {
      color: "#b7b7b7"
    },
    "& + svg": {
      display: (!error && touched) ? "block" : "none",
      position: "absolute",
      right: "8%",
      top: "20px",
      bottom: "20px",
      fill: "$primary",
      backgroundSize: "13px 13px",
      width: "13px",
      height: "13px"
    },
    "&:focus": {
      borderColor: "$primary"
    }
  }), [touched, error, isSummary]);

  return (
    <Field
      {...props}
      className={`${styles.toString()} ${className ?? ""}`}
    />
  );

}

const AmountTileWrap = styled("div", {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  width: "100%",
  marginTop: "32px",
  marginBottom: "16px",
  // "@bp4": {
  //   flexWrap: "wrap",
  //   label: {
  //     position: "relative",
  //     width: "25% !important",
  //     "& > span": {
  //       position: "absolute",
  //       top: "18px",
  //       left: "0",
  //       right: "0",
  //       fontSize: "20px",
  //       fontWeight: 500,
  //       color: "#3a3a3a",
  //       textAlign: "center"
  //     }
  //   }
  // }
});

const RadioTile = styled("div", {
  position: "relative",
  /* display: flex; */
  width: "100%",
  /* padding: 20px 0; */
  /* margin: 0 30px; */
  "input": {
    display: "none",
    "& + label": {
      cursor: "pointer",
      /* padding-left: 25px; */
      fontSize: "14px",
      color: "#737373",
      "&:hover": {
        [`& ${RadioButton}`]: {
          backgroundColor: "#e1e1e1"
        }
      }
    },
    "&:checked + label": {
      cursor: "default",
      [`& ${RadioButton}`]: {
        color: "#fff",
        backgroundColor: "$primary !important",
        borderColor: "$important",
        /* &:after {
          display: block;
          top: 3px;
          left: 3px;
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background: #ff6e00;
        } */
      }
    }
  }
});

const Wrap = styled("div", {
  backgroundColor: "transparent",
  display: "flex",
  flexDirection: "column",
  width: "100%",
  zIndex: 10,
  "form": {
    fontSize: "14px",
    [`& ${RadioTile}:not(:last-of-type)`]: {
      borderBottom: "1px solid #eee"
    }
  },
  "@bp4": {
    width: "100%"
  }
});

export default BridDonate;
